module.exports = __webpack_public_path__ + "static/media/app.e9357961.png";